// STATUS: draft — needs native-speaker check before live
// Arabic (Modern Standard Arabic) visitor messages (task TR1, docs/modules/languages.md s2). Right-to-left: layout is handled elsewhere. Visitor keys only; missing keys fall back to en-GB.
export const arVisitor = {
    'kiosk.pairing.title': 'إعداد هذا الكشك',
    'kiosk.pairing.hint': 'أدخل الرمز من بوابة CloudSign.',
    'kiosk.pairing.go': 'ربط',
    'kiosk.pairing.codeLabel': 'رمز الربط',
    'kiosk.pairing.checking': 'جارٍ التحقق من الرمز…',
    'kiosk.pairing.clear': 'مسح',
    'kiosk.pairing.back': 'حذف الرقم الأخير',
    'kiosk.pairing.invalid': 'هذا الرمز غير صالح أو انتهت صلاحيته. يُرجى طلب رمز جديد.',
    'kiosk.pairing.noNetwork': 'تعذّر الاتصال بـ CloudSign. يُرجى التحقق من شبكة Wi-Fi والمحاولة مرة أخرى.',
    'kiosk.common.back': 'رجوع',
    'kiosk.common.next': 'التالي',
    'kiosk.common.continue': 'متابعة',
    'kiosk.common.cancel': 'إلغاء',
    'kiosk.common.yes': 'نعم',
    'kiosk.common.no': 'لا',
    'kiosk.welcome.tap': 'اضغط هنا لتسجيل الحضور أو الانصراف',
    'kiosk.welcome.offline': 'غير متصل: تُحفظ عمليات التسجيل وتُرسل لاحقاً',
    'kiosk.home.title': 'ماذا تودّ أن تفعل؟',
    'kiosk.home.signIn': 'تسجيل الحضور',
    'kiosk.home.signOut': 'تسجيل الانصراف',
    'kiosk.home.scan': 'مسح بطاقتي',
    'kiosk.groups.titleIn': 'بصفة مَن تسجّل حضورك؟',
    'kiosk.groups.titleOut': 'بصفة مَن تسجّل انصرافك؟',
    'kiosk.groups.hint': 'اختر الخيار الأنسب لك.',
    'kiosk.groups.repeat': 'الأعضاء المعتادون',
    'kiosk.pin.hint': 'أدخل رقم التعريف الشخصي المكوّن من 4 أرقام.',
    'kiosk.pin.entered': 'تم إدخال {count} من 4 أرقام',
    'kiosk.pin.wrong': 'رقم التعريف الشخصي غير صحيح. يُرجى المحاولة مرة أخرى.',
    'kiosk.pin.locked': 'محاولات كثيرة بأرقام خاطئة. إدخال رقم التعريف مقفل لبضع دقائق. يُرجى طلب المساعدة.',
    'kiosk.pin.clear': 'مسح',
    'kiosk.pin.back': 'حذف الرقم الأخير',
    'kiosk.identify.title': 'ابحث عن اسمك',
    'kiosk.identify.placeholder': 'ابدأ بكتابة اسمك',
    'kiosk.identify.none': 'لم يُعثر على أي شخص بهذا الاسم.',
    'kiosk.identify.addSelf': 'لستُ في القائمة',
    'kiosk.addSelf.title': 'أضف اسمك',
    'kiosk.name.title': 'ما اسمك؟',
    'kiosk.name.label': 'اسمك',
    'kiosk.name.fullNameHint': 'يُرجى إدخال الاسم الأول واسم العائلة.',
    'kiosk.already.message': 'تم تسجيل حضورك بالفعل. هل تودّ تسجيل الانصراف بدلاً من ذلك؟',
    'kiosk.already.signOut': 'سجّل انصرافي',
    'kiosk.questions.titleIn': 'بضعة أسئلة سريعة',
    'kiosk.questions.titleOut': 'قبل المغادرة',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'فهمتُ ذلك',
    'kiosk.questions.hostSearch': 'اكتب اسم الشخص الذي تزوره',
    'kiosk.questions.changeHost': 'تغيير',
    'kiosk.notices.progress': 'الإشعار {n} من {total}',
    'kiosk.notices.accept': 'قرأتُ هذا وأوافق عليه',
    'kiosk.notices.sign': 'توقيع',
    'kiosk.notices.signHere': 'يُرجى التوقيع بإصبعك.',
    'kiosk.signature.pad': 'مربع التوقيع',
    'kiosk.signature.clear': 'مسح التوقيع',
    'kiosk.signature.captured': 'تم حفظ التوقيع',
    'kiosk.photo.title': 'صورة',
    'kiosk.photo.hint': 'انظر إلى الكاميرا واضغط على الزر.',
    'kiosk.photo.take': 'التقاط صورتي',
    'kiosk.photo.getReady': 'استعد…',
    'kiosk.photo.retake': 'إعادة التقاط',
    'kiosk.photo.use': 'استخدام هذه الصورة',
    'kiosk.photo.skip': 'تخطي الصورة',
    'kiosk.photo.failed': 'لم تنجح الصورة. يُرجى المحاولة مرة أخرى.',
    'kiosk.photo.noCamera': 'الكاميرا غير متاحة. يمكنك المتابعة دون صورة.',
    'kiosk.photo.privacy': 'تُستخدم صورتك فقط للبطاقة وسجل الزيارة.',
    'kiosk.badge.title': 'بطاقتك',
    'kiosk.badge.ask': 'هل تودّ الحصول على بطاقة؟',
    'kiosk.badge.yes': 'طباعة بطاقتي',
    'kiosk.badge.no': 'لا، شكراً',
    'kiosk.badge.printing': 'جارٍ طباعة بطاقتك…',
    'kiosk.badge.done': 'يُرجى استلام بطاقتك',
    'kiosk.badge.failed': 'عذراً، لم تُطبع البطاقة. تم تسجيل حضورك. يُرجى طلب بطاقة من الاستقبال.',
    'kiosk.signout.title': 'ابحث عن اسمك لتسجيل الانصراف',
    'kiosk.signout.search': 'البحث بالاسم',
    'kiosk.signout.hiddenHint': 'حفاظاً على الخصوصية لا تُعرض الأسماء. اكتب اسمك أو امسح بطاقتك.',
    'kiosk.signout.empty': 'لا يوجد أحد مسجّل.',
    'kiosk.signout.noMatch': 'لم يُعثر على أحد. حاول مرة أخرى أو امسح بطاقتك.',
    'kiosk.signout.unnamed': 'زائر',
    'kiosk.scan.title': 'امسح بطاقتك',
    'kiosk.scan.hint': 'أمسك رمز QR الموجود على بطاقتك أمام الكاميرا.',
    'kiosk.scan.allow': 'السماح بالكاميرا',
    'kiosk.scan.noCamera': 'الكاميرا غير متاحة. يُرجى اختيار اسمك من القائمة.',
    'kiosk.scan.notBadge': 'هذه ليست بطاقة CloudSign. يُرجى المحاولة مرة أخرى.',
    'kiosk.scan.notSignedIn': 'هذه البطاقة غير مسجّلة هنا. يُرجى اختيار اسمك من القائمة.',
    'kiosk.finish.inTitle': 'شكراً، {name}',
    'kiosk.finish.inMessage': 'تم تسجيل حضورك.',
    'kiosk.finish.outTitle': 'إلى اللقاء، {name}',
    'kiosk.finish.outMessage': 'تم تسجيل انصرافك. رحلة آمنة!',
    'kiosk.finish.tap': 'اضغط للإنهاء',
    'kiosk.update.title': 'يحتاج هذا الكشك إلى تحديث',
    'kiosk.update.message': 'يحتاج هذا الكشك إلى تحديث قبل أن يتمكن من تسجيل حضورك. يُرجى السؤال في الاستقبال.',
    'kiosk.update.short': 'يحتاج إلى تحديث',
    'kiosk.error.required': 'يُرجى الإجابة عن هذا السؤال.',
    'kiosk.error.mustAcknowledge': 'يُرجى وضع علامة للتأكيد.',
    'kiosk.error.nameRequired': 'يُرجى كتابة اسمك.',
    'kiosk.error.fullName': 'يُرجى إدخال الاسم الأول واسم العائلة.',
    'kiosk.error.tooLong': 'هذه الإجابة طويلة جداً.',
    'kiosk.error.number': 'يُرجى إدخال رقم.',
    'kiosk.error.wholeNumber': 'يُرجى إدخال عدد صحيح.',
    'kiosk.error.range': 'هذا الرقم خارج النطاق المسموح به.',
    'kiosk.error.email': 'يُرجى إدخال عنوان بريد إلكتروني صالح.',
    'kiosk.error.phone': 'يُرجى إدخال رقم هاتف صالح.',
    'kiosk.error.date': 'يُرجى إدخال تاريخ مثل 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'تعني هذه الإجابة أنه لا يمكنك تسجيل حضورك هنا. يُرجى التحدث مع الاستقبال.',
    'kiosk.print.state.ready': 'الطابعة جاهزة',
    'kiosk.print.state.no_media': 'نفدت الملصقات من الطابعة',
    'kiosk.print.state.cover_open': 'غطاء الطابعة مفتوح',
    'kiosk.print.state.media_mismatch': 'الملصقات المحمّلة في الطابعة غير صحيحة',
    'kiosk.print.state.busy': 'الطابعة مشغولة',
    'kiosk.print.state.error': 'أبلغت الطابعة عن مشكلة',
    'kiosk.print.state.unreachable': 'تعذّر الوصول إلى الطابعة',
    'kiosk.print.state.unknown': 'حالة الطابعة غير معروفة',
    'kiosk.home.expected': 'لديّ موعد',
    'kiosk.home.scanCode': 'مسح رمز QR الخاص بي',
    'kiosk.scan.titleCode': 'امسح رمز QR الخاص بك',
    'kiosk.scan.hintCode': 'أمسك رمز QR من بريدك الإلكتروني أو بطاقتك أو بطاقة التعريف أمام الكاميرا.',
    'kiosk.scan.invalid': 'رمز QR هذا غير صالح هنا. حاول مرة أخرى أو اختر اسمك من القائمة.',
    'kiosk.scan.notSupported': 'لا يستطيع هذا الكشك استخدام هذا النوع من رموز QR. يُرجى اختيار اسمك من القائمة.',
    'kiosk.scan.unknownMember': 'رمز QR هذا غير معروف في هذا الكشك. يُرجى اختيار اسمك من القائمة.',
    'kiosk.scan.oldCode': 'تم استبدال رمز QR هذا برمز جديد. يُرجى استخدام الأحدث أو اختيار اسمك.',
    'kiosk.scan.notHere': 'رمز QR هذا ليس لهذا الكشك.',
    'kiosk.scan.notExpected': 'لا نتوقع حضورك اليوم بهذا الرمز. يُرجى السؤال في الاستقبال.',
    'kiosk.scan.cancelled': 'تم إلغاء هذه الزيارة. يُرجى السؤال في الاستقبال.',
    'kiosk.scan.alreadyArrived': 'تم استخدام رمز QR هذا من قبل لتسجيل الحضور.',
    'kiosk.scan.expired': 'انتهت صلاحية رمز QR هذا. يُرجى السؤال في الاستقبال.',
    'kiosk.expected.title': 'من أنت؟',
    'kiosk.expected.search': 'ابدأ بكتابة اسمك',
    'kiosk.expected.exactHint': 'يُرجى كتابة اسمك الكامل تماماً كما أُعطي لنا.',
    'kiosk.expected.requiredHint': 'يجب أن تكون متوقعاً لتسجيل حضورك هنا. ابحث عن اسمك أو امسح رمز QR الخاص بك.',
    'kiosk.expected.none': 'لم نجد هذا الاسم في قائمة اليوم. يُرجى السؤال في الاستقبال.',
    'kiosk.expected.empty': 'لا يوجد أحد متوقع في الوقت الحالي.',
    'kiosk.expected.visiting': 'زيارة {host}',
    'kiosk.expected.required': 'يجب أن تكون متوقعاً لتسجيل حضورك هنا. يُرجى السؤال في الاستقبال.',
    'kiosk.signout.outMark': 'خارج',
    'kiosk.signout.outToday': 'تم تسجيل الانصراف اليوم',
    'kiosk.hostReply.on_my_way': '{host} في الطريق.',
    'kiosk.hostReply.please_wait': '{host} يطلب منك الانتظار، من فضلك.',
    'kiosk.hostReply.someone': 'المضيف',
    'kiosk.hostReply.dismiss': 'حسناً',
    'kiosk.evacuation.notAllowed': 'لا يمكن بدء الإخلاء من هذا الكشك.',
    'kiosk.evacuation.wrongPin': 'رقم التعريف الشخصي غير صحيح.',
    'kiosk.evacuation.pinLocked': 'محاولات كثيرة بأرقام خاطئة. يُرجى الانتظار بضع دقائق.',
    'kiosk.evacuation.startFailed': 'تعذّر بدء الإخلاء. يُرجى المحاولة مرة أخرى.',
    'kiosk.nfc.enrolOffline': 'هذا الكشك غير متصل. لا يمكن تسجيل البطاقات إلا عندما يكون متصلاً.',
    'kiosk.nfc.enrolExpired': 'انتهى تسجيل هذه البطاقة أو انتهت مهلته.',
    'kiosk.nfc.enrolFailed': 'تعذّر تسجيل هذه البطاقة. يُرجى تجربة بطاقة أخرى.',
    'kiosk.nfc.enrolTapAgain': 'يُرجى تقريب البطاقة مرة أخرى.',
    'kiosk.common.ok': 'حسناً',
    'kiosk.welcome.stale': 'كان هذا الكشك غير متصل لفترة طويلة. يُرجى إبلاغ الاستقبال.',
    'kiosk.welcome.busy': 'الموقع مزدحم في الوقت الحالي. إذا كنت زائراً، يُرجى إبلاغ الاستقبال.',
    'kiosk.welcome.evacuation': 'إخلاء',
    'kiosk.home.delivery': 'أقوم بتسليم طرد',
    'kiosk.check.seeReceptionTitle': 'يُرجى مراجعة الاستقبال',
    'kiosk.check.warnTitle': 'قبل المتابعة',
    'kiosk.full.short': 'الموقع مكتمل',
    'kiosk.full.title': 'الموقع مكتمل',
    'kiosk.full.message': 'لا يمكننا تسجيل المزيد من الزوار في الوقت الحالي. يُرجى مراجعة الاستقبال.',
    'kiosk.induction.subtitle': 'تعريف الموقع',
    'kiosk.induction.unavailable': 'تعريف الموقع غير متاح في هذا الكشك. يُرجى مراجعة الاستقبال.',
    'kiosk.induction.videoMissing': 'الفيديو غير موجود في هذا الكشك بعد. يُرجى قراءة النص أدناه.',
    'kiosk.induction.pdfNote': 'يُرجى قراءة نص التعريف أدناه. اسأل الاستقبال إذا كنت تريد المستند.',
    'kiosk.induction.wait': 'يُرجى الانتظار {seconds} ثانية',
    'kiosk.induction.startQuiz': 'ابدأ الأسئلة',
    'kiosk.induction.question': 'السؤال {n} من {total}',
    'kiosk.induction.chooseMany': 'اختر كل الإجابات الصحيحة.',
    'kiosk.induction.finish': 'إنهاء',
    'kiosk.induction.retryTitle': 'ليس بعد',
    'kiosk.induction.retryMessage': 'بعض الإجابات لم تكن صحيحة. يُرجى المحاولة مرة أخرى مع {count}.',
    'kiosk.induction.retryButton': 'حاول مرة أخرى',
    'kiosk.permits.title': 'تصاريح العمل الخاصة بك',
    'kiosk.permits.unavailable': 'لا يمكن عرض تصاريحك الآن. يُرجى مراجعة الاستقبال قبل بدء العمل.',
    'kiosk.permits.allAccepted': 'لقد قبلت جميع تصاريحك.',
    'kiosk.permits.progress': 'التصريح {n} من {total}',
    'kiosk.permits.valid': 'من {from} حتى {until}',
    'kiosk.permits.conditions': 'الشروط',
    'kiosk.permits.precautions': 'الاحتياطات',
    'kiosk.permits.signHere': 'وقّع هنا للقبول، {name}',
    'kiosk.permits.accept': 'أقبل هذا التصريح',
    'kiosk.nfc.blocked': 'تم حظر هذه البطاقة',
    'kiosk.nfc.unknown': 'بطاقة غير معروفة',
    'kiosk.nfc.enrolTitle': 'تسجيل البطاقات',
    'kiosk.nfc.enrolProgress': 'تم {done} من {total}',
    'kiosk.nfc.enrolTapFor': 'قرّب البطاقة لـ',
    'kiosk.nfc.enrolHold': 'ضع البطاقة على خلفية الجهاز اللوحي.',
    'kiosk.nfc.enrolSaving': 'جارٍ الحفظ…',
    'kiosk.nfc.enrolOk': 'تم حفظ البطاقة.',
    'kiosk.nfc.enrolDone': 'تم تسجيل جميع البطاقات',
    'kiosk.nfc.noReader': 'لا يوجد قارئ بطاقات مفعّل في هذا الكشك.',
    'kiosk.evacuation.title': 'إخلاء',
    'kiosk.evacuation.drillTitle': 'تدريب على الحريق',
    'kiosk.evacuation.startTitle': 'بدء الإخلاء',
    'kiosk.evacuation.confirmTitle': 'بدء الإخلاء؟',
    'kiosk.evacuation.confirmMessage': 'سيؤدي هذا إلى تنبيه الجميع في الموقع وفتح قائمة الحضور.',
    'kiosk.evacuation.confirmStart': 'بدء الإخلاء',
    'kiosk.evacuation.leave': 'مغادرة قائمة الحضور',
    'kiosk.evacuation.leaveTitle': 'أدخل رقم التعريف الشخصي لمغادرة قائمة الحضور',
    'kiosk.evacuation.returnBanner': 'الإخلاء جارٍ. اضغط للعودة إلى قائمة الحضور.',
    'kiosk.evacuation.offline': 'غير متصل: تُحفظ علاماتك وتُرسل عند عودة الشبكة.',
    'kiosk.evacuation.localOnly': 'بدأ على هذا الكشك وهو غير متصل. سيُدمج مع البوابة عند عودة الشبكة.',
    'kiosk.evacuation.countUnaccounted': 'لم يُعثر عليهم بعد',
    'kiosk.evacuation.countSafe': 'في أمان',
    'kiosk.evacuation.countMissing': 'مفقود',
    'kiosk.evacuation.countTotal': 'في الموقع',
    'kiosk.evacuation.allPoints': 'الجميع',
    'kiosk.evacuation.search': 'البحث بالاسم',
    'kiosk.evacuation.onlyOpen': 'ليس في أمان بعد',
    'kiosk.evacuation.loading': 'جارٍ تحميل قائمة الحضور…',
    'kiosk.evacuation.nobody': 'لا يوجد أحد لعرضه.',
    'kiosk.evacuation.safe': 'في أمان',
    'kiosk.evacuation.markedSafe': 'في أمان (اضغط للتراجع)',
    'kiosk.evacuation.missing': 'مفقود',
    'kiosk.evacuation.markedMissing': 'مفقود (اضغط للتراجع)',
    'kiosk.evacuation.host': 'المضيف: {name}',
    'kiosk.evacuation.check': 'تحقق',
    'kiosk.evacuation.permits': '{count} تصريح مفتوح',
    'kiosk.contactless.qrLabel': 'امسح هذا الرمز بهاتفك لتسجيل الحضور',
    'kiosk.contactless.scanMe': 'سجّل حضورك بهاتفك',
    'kiosk.courier.whoTitle': 'لمن هذا الطرد؟',
    'kiosk.courier.whoHint': 'اكتب بعض حروف اسمه.',
    'kiosk.courier.search': 'اسم الشخص',
    'kiosk.courier.useName': 'استخدام «{name}»',
    'kiosk.courier.useNameHint': 'سيقوم الاستقبال بتسليمه',
    'kiosk.courier.carrierTitle': 'من أي شركة أنت؟',
    'kiosk.courier.forName': 'طرد إلى {name}',
    'kiosk.courier.other': 'أخرى',
    'kiosk.courier.otherLabel': 'اسم الشركة',
    'kiosk.courier.countTitle': 'كم عدد الطرود؟',
    'kiosk.courier.howMany': 'عدد الطرود',
    'kiosk.courier.save': 'تم',
    'kiosk.courier.thanks': 'شكراً',
    'kiosk.courier.thanksMessage': 'أبلغنا المستلم بأن طرده قد وصل.',
    'kiosk.support.pinTitle': 'الدعم: أدخل رقم التعريف الشخصي',
    'kiosk.support.title': 'الدعم',
    'kiosk.support.close': 'إغلاق',
    'kiosk.support.network': 'الشبكة',
    'kiosk.support.online': 'متصل',
    'kiosk.support.offline': 'غير متصل',
    'kiosk.support.queue': 'في انتظار الإرسال',
    'kiosk.support.oldest': 'الأقدم في الانتظار منذ',
    'kiosk.support.none': 'لا شيء',
    'kiosk.support.deadLetters': 'رفضها الخادم (لم تُرسل)',
    'kiosk.support.deadHelp': 'رفض الخادم هذه العناصر، وهي باقية في هذا الكشك. أبلغ المسؤول؛ تعرض صفحة الجهاز في البوابة عددها.',
    'kiosk.support.configAge': 'آخر تحديث للإعدادات',
    'kiosk.support.ageUnknown': 'أبداً',
    'kiosk.support.ageMinutes': 'منذ {n} دقيقة',
    'kiosk.support.ageHours': 'منذ {n} ساعة',
    'kiosk.support.ageDays': 'منذ {n} يوماً',
    'kiosk.support.nfc': 'قارئ البطاقات',
    'kiosk.support.nfcReady': 'جاهز',
    'kiosk.support.nfcOff': 'مُطفأ',
    'kiosk.support.nfcNone': 'غير مركّب',
    'kiosk.support.media': 'مقاطع الفيديو المخزّنة',
    'kiosk.support.mediaMb': '{mb} م.ب',
    'kiosk.support.headcount': 'الأشخاص في الموقع (هذا الكشك)',
    'kiosk.finish.poweredBy': 'مدعوم بواسطة CloudSign',
    'kiosk.badge.noMedia': 'نفدت الملصقات من طابعة البطاقات. تم تسجيل حضورك. يُرجى إبلاغ الاستقبال.',
    'kiosk.badge.mediaMismatch': 'الملصقات المحمّلة في طابعة البطاقات غير صحيحة. تم تسجيل حضورك. يُرجى إبلاغ الاستقبال.',
    'kiosk.badge.coverOpen': 'غطاء طابعة البطاقات مفتوح. تم تسجيل حضورك. يُرجى إبلاغ الاستقبال.',
    'kiosk.member.menuTitle': 'ماذا تودّ أن تفعل؟',
    'kiosk.member.signIn': 'سجّل حضوري',
    'kiosk.member.updatePhoto': 'تحديث صورتي',
    'kiosk.member.sendInvite': 'أرسل لي دعوة التطبيق',
    'kiosk.memberPhoto.title': 'حدّث صورتك',
    'kiosk.memberPhoto.saved': 'تم تحديث صورتك.',
    'kiosk.memberPhoto.failed': 'تعذّر حفظ صورتك. يُرجى المحاولة مرة أخرى أو السؤال في الاستقبال.',
    'kiosk.memberPhoto.offline': 'هذا الكشك غير متصل، لذا لا يمكن تحديث صورتك الآن.',
    'kiosk.memberPhoto.notAllowed': 'لا يمكن تحديث صورتك على الكشك. يُرجى السؤال في الاستقبال.',
    'kiosk.invite.title': 'احصل على تطبيق CloudSign',
    'kiosk.invite.sent': 'أرسلنا إليك رابطاً عبر البريد الإلكتروني لإعداد التطبيق. يُرجى التحقق من صندوق الوارد.',
    'kiosk.invite.noEmail': 'ليس لدينا عنوان بريد إلكتروني لك، لذا تعذّر إرسال الدعوة. يُرجى السؤال في الاستقبال.',
    'kiosk.invite.tooMany': 'طلبت عدداً كبيراً من الدعوات اليوم. يُرجى المحاولة غداً.',
    'kiosk.invite.failed': 'تعذّر إرسال الدعوة. يُرجى المحاولة مرة أخرى أو السؤال في الاستقبال.',
    'kiosk.invite.offline': 'هذا الكشك غير متصل، لذا لا يمكن إرسال دعوة الآن.',
    'kiosk.invite.sending': 'جارٍ إرسال دعوتك…',
    'kiosk.language.choose': 'اختر لغتك',
    'kiosk.language.button': 'اللغة',
    'public.language.label': 'اللغة',
    'contactless.thank_you': 'شكراً. تم تسجيل حضورك.',
    'contactless.thank_you_out': 'شكراً. تم تسجيل انصرافك.',
    'contactless.poster.title': 'امسح للتسجيل',
    'contactless.poster.hint': 'وجّه كاميرا هاتفك نحو الرمز. لا حاجة إلى تطبيق.',
    'check.safety_check.refused': 'يُرجى مراجعة الاستقبال قبل تسجيل الحضور.',
    'check.safety_check.alert': 'سُمح بالدخول مع تنبيه للاستقبال (فحص السلامة).',
    'check.compliance.refused': 'مستند مطلوب مفقود أو منتهي الصلاحية. يُرجى مراجعة الاستقبال.',
    'check.compliance.warned': 'مستند مطلوب مفقود أو منتهي الصلاحية.',
    'check.induction.required': 'يُرجى إكمال تعريف الموقع أولاً.',
    'check.capacity.full': 'الموقع مكتمل في الوقت الحالي. يُرجى مراجعة الاستقبال.',
    'check.capacity.warned': 'تم تسجيل الحضور بينما كان الموقع يتجاوز طاقته الاستيعابية.',
    'check.offline': 'سُجّل أثناء عدم اتصال الكشك.',
};
//# sourceMappingURL=ar.js.map